import React, { useState, useEffect } from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

const allRows_US = [
  {
    id: 'us_row1',
    scenario: {
      value: (
        <div>
          Successful authentication:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Successful authentication</li>
            <li>Successful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719460707704</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879786234393</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "Y"\n
        }
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row2',
    scenario: {
      value: (
        <div>
          Failed signature:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Successful authentication</li>
            <li>Unsuccessful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719115514992</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879785160250</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "UNKNOWN",\n
          "three_d_secure": {\n
            "enrollment_status": "Y",\n
            "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row3',
    scenario: {
      value: (
        <div>
          Failed authentication:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Unsuccessful authentication</li>
            <li>Successful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719796782421</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879743856650</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result":{\n
          "liability_shift": "NO",\n
        "three_d_secure":{\n
          "enrollment_status": "Y",\n
          "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row4',
    scenario: {
      value: (
        <div>
          Attempts/Non-Participating:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Not prompted for authentication credential</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719041085422</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879703852350</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "POSSIBLE",\n
          "three_d_secure": {\n
            "enrollment_status": "Y",\n
            "authentication_status": "A"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row5',
    scenario: {
      value: 'Timeout',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719494697210</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879747163939</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row6',
    scenario: {
      value: 'Not Enrolled',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719632978803</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879761823947</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
          "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row7',
    scenario: {
      value: (
        <div>
          Unavailable:
          <ul>
            <li>Cardholder enrolled</li>
            <li>system is unavailable</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719632978803</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879761823947</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
          "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row8',
    scenario: {
      value: 'Merchant Not Active',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719013686405</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879767479553</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row9',
    scenario: {
      value: 'cmpi_lookup error',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719489473346</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879717927867</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row10',
    scenario: {
      value: (
        <div>
          cmpi_authenticate error
          <ul>
            <li>Cardholder is enrolled</li>
            <li>Error with the authentication</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719501254542</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879770784023</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
            "enrollment_status": "Y",\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row11',
    scenario: {
      value: (
        <div>
          Authentication unavailable:
          <ul>
            <li>Cardholder is enrolled</li>
            <li>Authentication is unavailable</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719115738815</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879746440940</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row12',
    scenario: {
      value: 'Bypassed Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719718773896</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879754369577</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
          "enrollment_status": "B",\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row13',
    scenario: {
      value: 'Successful Frictionless',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719196829038</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879707824603</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "POSSIBLE",\n
          "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "Y"\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row14',
    scenario: {
      value: 'Failed Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719158130060</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879769571910</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "N"\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row15',
    scenario: {
      value: 'Attempts Stand-In Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719581920723</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879715396727</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "POSSIBLE",\n
          "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "A"\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row16',
    scenario: {
      value: 'Unavailable Frictionless Authentication from the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719033482561</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879705777613</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row17',
    scenario: {
      value: 'Rejected Frictionless Authentication by the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719081564153</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5319541865518409</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "R"\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row18',
    scenario: {
      value: 'Authentication Not Available on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719488651967</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879714462553</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
          "enrollment_status": "U",\n
          }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row19',
    scenario: {
      value: 'Error on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719212118267</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879799002902</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row20',
    scenario: {
      value: 'Timeout on cmpi_lookup Transaction',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719447403153</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879712676014</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row21',
    scenario: {
      value: 'Successful Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719166101368</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879735316929</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row22',
    scenario: {
      value: 'Failed Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719181895556</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879768013724</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row23',
    scenario: {
      value: 'Step-Up Authentication is Unavailable',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719557718580</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879734808405</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row24',
    scenario: {
      value: 'Error on Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719841831470</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879759348949</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "UNKNOWN",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row25',
    scenario: {
      value: 'Bypassed Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719387168584</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879774090658</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "B",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row26',
    scenario: {
      value: 'Require MethodURL',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4868719420856260</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5329879778167759</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row27',
    scenario: {
      value: 'Suspected Fraud',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719414353647</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
          "liability_shift": "NO",\n
          "three_d_secure": {\n
          "enrollment_status": "Y",\n
          "authentication_status": "R"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row28',
    scenario: {
      value: 'Cardholder Not Enrolled in Service',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719272965169</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row29',
    scenario: {
      value: 'Transaction timed out at the Access Control Server',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719242028502</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row30',
    scenario: {
      value: 'Non-Payment transaction not supported',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719696031259</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row31',
    scenario: {
      value:
        'Merchant-Initiated Authentication (3RI) transaction not supported',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719785718543</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row32',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Mastercard',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5329879716900121</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row33',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Mastercard',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5329879767403439</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row34',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Visa',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719664345830</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "I"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row35',
    scenario: {
      value: 'Prompt For Whitelist',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719995056080</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row36',
    scenario: {
      value: 'Utilize Trusted Beneficiary Exemption',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4868719117473452</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row37',
    scenario: {
      value: 'Identity Check Insights (ScoreRequest = N)',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5329879747887362</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'us_row38',
    scenario: {
      value: 'Identity Check Insights (ScoreRequest = Y)',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5329879702238494</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
]

const allRows_GB = [
  {
    id: 'gb_row1',
    scenario: {
      value: 'Test Case 1: Successful Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603042343024</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996018452</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row2',
    scenario: {
      value: 'Test Case 2: Failed Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603045503384</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996477518</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "N" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row3',
    scenario: {
      value: 'Test Case 3: Attempts Stand-In Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603046653873</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996491832</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "A" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row4',
    scenario: {
      value:
        'Test Case 4: Unavailable Frictionless Authentication from the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603040650784</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996100821</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row5',
    scenario: {
      value: 'Test Case 5: Rejected Frictionless Authentication by the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603047907062</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996727748</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "R" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row6',
    scenario: {
      value: 'Test Case 6: Authentication Not Available on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603049870995</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996936430</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "U", } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row7',
    scenario: {
      value: 'Test Case 7: Error on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603043330905</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996965611</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "U", } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row8',
    scenario: {
      value: 'Test Case 8: Timeout on cmpi_lookup Transaction',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603046336610</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996701214</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", }`}</code>
      ),
    },
  },
  {
    id: 'gb_row9',
    scenario: {
      value: 'Test Case 9: Successful Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603040971339</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996617055</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row10',
    scenario: {
      value: 'Test Case 10: Failed Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603043025620</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996452719</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "N" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row11',
    scenario: {
      value: 'Test Case 11: Step-Up Authentication is Unavailable',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603040318820</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996698402</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row12',
    scenario: {
      value: 'Test Case 12: Error on Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603041142476</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996899844</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row13',
    scenario: {
      value: 'Test Case 13: Bypassed Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603043209109</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996140389</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "B", } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row14',
    scenario: {
      value: 'Test Case 1a. Initial/First Recurring Transaction',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996242292</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row15',
    scenario: {
      value:
        'Test Case 1b. Recurring Payments - Subsequent Transaction (Mastercard)',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996432984</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row16',
    scenario: {
      value: 'Test Case 3b. Transaction Risk Analysis (TRA) / Low Value',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603044165854</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996251996</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "N" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row17',
    scenario: {
      value: 'Test Case 4a: Prompt For Trustlist',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603043176951</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996416771</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row18',
    scenario: {
      value: 'Test Case 4b: Utilize Trusted Beneficiary Exemption',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603042259147</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="Mastercard logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5120069996486204</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "POSSIBLE", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "Y" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row19',
    scenario: {
      value: 'Test Case 5a: Visa Data Only',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603040398418</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row20',
    scenario: {
      value: 'Test Case 6a: Visa Delegated Authentication (Success)',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603042399026</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row21',
    scenario: {
      value: 'Test Case 6b: Issuer Not Participating (Error)',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603049494333</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "N" } }`}</code>
      ),
    },
  },
  {
    id: 'gb_row22',
    scenario: {
      value: 'Test Case 6c: VMID Not Registered (Error)',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="Visa logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4462603046744326</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>{`"authentication_result": { "liability_shift": "NO", "three_d_secure": { "enrollment_status": "Y", "authentication_status": "U" } }`}</code>
      ),
    },
  },
]

const allRows_FR = [
  {
    id: 'fr_row1',
    scenario: {
      value: (
        <div>
          Successful authentication:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Successful authentication</li>
            <li>Successful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020027756720802</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010949575</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row2',
    scenario: {
      value: (
        <div>
          Failed signature:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Successful authentication</li>
            <li>Unsuccessful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020023540173739</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010232238</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "UNKNOWN",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row3',
    scenario: {
      value: (
        <div>
          Failed authentication:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Unsuccessful authentication</li>
            <li>Successful signature verification</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020028124867168</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010673191</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row4',
    scenario: {
      value: (
        <div>
          Attempts/Non-Participating:
          <ul>
            <li>Cardholder enrolled</li>
            <li>Not prompted for authentication credential</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020022745417552</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010915683</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "A"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row5',
    scenario: {
      value: 'Timeout',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020027027199174</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010919818</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row6',
    scenario: {
      value: 'Not Enrolled',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020026678521256</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010052065</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row7',
    scenario: {
      value: (
        <div>
          Unavailable:
          <ul>
            <li>Cardholder enrolled</li>
            <li>system is unavailable</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020024702378421</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010445905</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row8',
    scenario: {
      value: 'Merchant Not Active',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020024608960074</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010609245</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row9',
    scenario: {
      value: 'cmpi_lookup error',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020027374648419</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010622586</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row10',
    scenario: {
      value: (
        <div>
          cmpi_authenticate error
          <ul>
            <li>Cardholder is enrolled</li>
            <li>Error with the authentication</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020028104962773</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010811395</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row11',
    scenario: {
      value: (
        <div>
          Authentication unavailable:
          <ul>
            <li>Cardholder is enrolled</li>
            <li>Authentication is unavailable</li>
          </ul>
        </div>
      ),
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020020112470089</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010798782</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row12',
    scenario: {
      value: 'Bypassed Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020020027219498</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010834157</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "B",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row13',
    scenario: {
      value: 'Successful Frictionless',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020022897166841</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010647179</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row14',
    scenario: {
      value: 'Failed Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020027785964843</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010056439</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row15',
    scenario: {
      value: 'Attempts Stand-In Frictionless Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020027621836130</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010084514</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "A"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row16',
    scenario: {
      value: 'Unavailable Frictionless Authentication from the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020026500805695</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010089604</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row17',
    scenario: {
      value: 'Rejected Frictionless Authentication by the Issuer',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020024335898241</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010432705</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "R"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row18',
    scenario: {
      value: 'Authentication Not Available on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020022046278208</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010626009</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row19',
    scenario: {
      value: 'Error on Lookup',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020021712502685</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010154622</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row20',
    scenario: {
      value: 'Timeout on cmpi_lookup Transaction',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020028479356601</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010045937</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row21',
    scenario: {
      value: 'Successful Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020022225423187</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010288321</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row22',
    scenario: {
      value: 'Failed Step-Up Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020028622515673</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010407350</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row23',
    scenario: {
      value: 'Step-Up Authentication is Unavailable',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020023821395589</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010789690</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row24',
    scenario: {
      value: 'Error on Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020029114018499</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010740065</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "UNKNOWN",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row25',
    scenario: {
      value: 'Bypassed Authentication',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020028406350594</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010328804</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "B",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row26',
    scenario: {
      value: 'Require MethodURL',
    },
    testCards: {
      value: (
        <div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
              alt="visa-logo"
              style={{
                width: '24px',
                height: '16px',
                backgroundColor: '#001c64',
              }}
            />
            <span style={{ marginLeft: '1rem' }}>Visa: </span>
            <code>4020024349144400</code>
          </div>
          <div>
            <img
              src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
              alt="mastercard-logo"
              style={{ width: '24px', height: '16px' }}
            />
            <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
            <code>5131015010362621</code>
          </div>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "U",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row27',
    scenario: {
      value: 'RCard Authentication Failed',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020021469766756</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
          "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row28',
    scenario: {
      value: 'Suspected Fraud',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020027297692841</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "R"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row29',
    scenario: {
      value: 'Cardholder Not Enrolled in Service',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020021607245523</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row30',
    scenario: {
      value: 'Transaction timed out at the Access Control Server',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020021607245523</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row31',
    scenario: {
      value: 'Non-Payment transaction not supported',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020029950962263</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row32',
    scenario: {
      value:
        'Merchant-Initiated Authentication (3RI) transaction not supported',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020020727035681</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row33',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Mastercard',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5131015010833829</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row34',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Mastercard',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5131015010405834</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "N"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row35',
    scenario: {
      value: 'Transaction Risk Analysis (TRA) / Low Value - Visa',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020026771790519</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "I"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row36',
    scenario: {
      value: 'Prompt For Whitelist',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020021574742023</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "POSSIBLE",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row37',
    scenario: {
      value: 'Utilize Trusted Beneficiary Exemption',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
            alt="visa-logo"
            style={{
              width: '24px',
              height: '16px',
              backgroundColor: '#001c64',
            }}
          />
          <span style={{ marginLeft: '1rem' }}>Visa: </span>
          <code>4020025752626502</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "Y"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row38',
    scenario: {
      value: 'Identity Check Insights (ScoreRequest = N)',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5131015010409679</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
  {
    id: 'fr_row39',
    scenario: {
      value: 'Identity Check Insights (ScoreRequest = Y)',
    },
    testCards: {
      value: (
        <div>
          <img
            src="https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
            alt="mastercard-logo"
            style={{ width: '24px', height: '16px' }}
          />
          <span style={{ marginLeft: '1rem' }}>Mastercard: </span>
          <code>5131015010810157</code>
        </div>
      ),
    },
    apiResponse: {
      value: (
        <code>
          {`"authentication_result": {\n
        "liability_shift": "NO",\n
        "three_d_secure": {\n
        "enrollment_status": "Y",\n
        "authentication_status": "U"\n
        }\n
      }`}
        </code>
      ),
    },
  },
]

const allRows_IT = [
  {
    id: 'it_row1',
    scenario:
    {
      value: 'Test Case 1: Successful Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385659642475 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586342391841 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "Y" } }`}</code > ),
    },
  },
  {
    id: 'it_row2',
    scenario:
    {
      value: 'Test Case 2: Failed Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385687543430 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586607301766 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "N" } }`}</code > ),
    },
  },
  {
    id: 'it_row3',
    scenario:
    {
      value: 'Test Case 3: Attempts Stand-In Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385601333769 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586428447392 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "A" } }`}</code > ),
    },
  },
  {
    id: 'it_row4',
    scenario:
    {
      value: 'Test Case 4: Unavailable Frictionless Authentication from the Issuer',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385668578231 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586058044832 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row5',
    scenario:
    {
      value: 'Test Case 5: Rejected Frictionless Authentication by the Issuer',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385690220737 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586672163869 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "R" } }`}</code > ),
    },
  },
  {
    id: 'it_row6',
    scenario:
    {
      value: 'Test Case 6: Authentication Not Available on Lookup',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385638350414 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586104283632 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row7',
    scenario:
    {
      value: 'Test Case 7: Error on Lookup',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385641821633 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586936559472 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row8',
    scenario:
    {
      value: 'Test Case 8: Timeout on cmpi_lookup Transaction',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385609069126 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586491030695 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row9',
    scenario:
    {
      value: 'Test Case 9: Successful Step-Up Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385699062981 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586654031019 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "Y" } }`}</code > ),
    },
  },
  {
    id: 'it_row10',
    scenario:
    {
      value: 'Test Case 10: Failed Step-Up Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385664948453 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586695482403 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "N" } }`}</code > ),
    },
  },
  {
    id: 'it_row11',
    scenario:
    {
      value: 'Test Case 11: Step-Up Authentication is Unavailable',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385633098885 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586239584342 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row12',
    scenario:
    {
      value: 'Test Case 12: Error on Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385667283668 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586585188573 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'it_row13',
    scenario:
    {
      value: 'Test Case 13: Bypassed Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4444385606686351 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5356586813587737 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "B" } }`}</code > ),
    },
  },
]

const allRows_SP = [
  {
    id: 'sp_row1',
    scenario:
    {
      value: 'Test Case 1: Successful Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845282500134 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070307987370 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "Y" } }`}</code > ),
    },
  },
  {
    id: 'sp_row2',
    scenario:
    {
      value: 'Test Case 2: Failed Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845282318990 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070302282793 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "N" } }`}</code > ),
    },
  },
  {
    id: 'sp_row3',
    scenario:
    {
      value: 'Test Case 3: Attempts Stand-In Frictionless Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845286554715 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070303057699 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "A" } }`}</code > ),
    },
  },
  {
    id: 'sp_row4',
    scenario:
    {
      value: 'Test Case 4: Unavailable Frictionless Authentication from the Issuer',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845284033514 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070305496283 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row5',
    scenario:
    {
      value: 'Test Case 5: Rejected Frictionless Authentication by the Issuer',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845285254754 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070304251358 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "R" } }`}</code > ),
    },
  },
  {
    id: 'sp_row6',
    scenario:
    {
      value: 'Test Case 6: Authentication Not Available on Lookup',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845285199413 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070307501767 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row7',
    scenario:
    {
      value: 'Test Case 7: Error on Lookup',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845285515345 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070301345187 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row8',
    scenario:
    {
      value: 'Test Case 8: Timeout on cmpi_lookup Transaction',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845280829881 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070307263533 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row9',
    scenario:
    {
      value: 'Test Case 9: Successful Step-Up Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845288980280 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070305863912 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "POSSIBLE","enrollment_status": "Y","authentication_status": "Y" } }`}</code > ),
    },
  },
  {
    id: 'sp_row10',
    scenario:
    {
      value: 'Test Case 10: Failed Step-Up Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845282721458 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070300481876 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "N" } }`}</code > ),
    },
  },
  {
    id: 'sp_row11',
    scenario:
    {
      value: 'Test Case 11: Step-Up Authentication is Unavailable',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845284001917 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070306052176 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row12',
    scenario:
    {
      value: 'Test Case 12: Error on Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845289672605 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070301888897 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "Y","authentication_status": "U" } }`}</code > ),
    },
  },
  {
    id: 'sp_row13',
    scenario:
    {
      value: 'Test Case 13: Bypassed Authentication',
    },
    testCards:
    {
      value: ( < div > < div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/visa-monotone.svg"
        alt = "Visa logo"
        style = {
          {
            width: '24px',
            height: '16px',
            backgroundColor: '#001c64'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Visa: </span > < code > 4791845284179341 < /code></div >
        <
        div > < img src = "https://www.paypalobjects.com/paypal-ui/logos/svg/mastercard-color.svg"
        alt = "Mastercard logo"
        style = {
          {
            width: '24px',
            height: '16px'
          }
        }
        /><span style={{ marginLeft: '1rem' }}>Mastercard: </span > < code > 5101070306638438 < /code></div > < /div>),},apiResponse: {value: (<code>{`"authentication_result": { "liability_shift": "NO","enrollment_status": "B" } }`}</code > ),
    },
  },
]

const columns = {
  scenario: {
    title: 'Scenario',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  testCards: {
    title: 'Test cards',
    mobile: {
      placement: 'b3',
    },
  },
  apiResponse: {
    title: 'API response',
    mobile: {
      placement: 'b3',
    },
  },
}

const options = {
  threshold: 0.4,
  keys: ['scenario.value'],
}

const TestScenarios = ({
  country,
  type,
}: {
  country?: string
  type: string
}) => {
  const [allRows, setAllRows] = useState(allRows_US)
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const showSeeMoreBtn = rows.length < allRows.length
  const [filteredRows, setFilteredRows] = useState([])
  const fuse = new Fuse(allRows, options)

  useEffect(() => {
    let selectedRow
    switch (country) {
      case 'gb':
        selectedRow = allRows_GB
        break
      case 'fr':
        selectedRow = allRows_FR
        break
      case 'it':
        selectedRow = allRows_IT
        break
      case 'sp':
        selectedRow = allRows_SP
        break
      default:
        selectedRow = allRows_US
    }
    setAllRows(selectedRow)
    setRows(selectedRow.slice(0, 5))
  }, [country, type])

  useEffect(() => {
    if (searchInput) {
      setFilteredRows(fuse.search(searchInput).map(({ item }) => item))
    } else {
      setFilteredRows([])
    }
  }, [searchInput])

  const handleTextChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleSeeMore = () => {
    setSearchInput('')
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <TextInput
        name="basic"
        value={searchInput}
        label="Search table"
        labelClassName="test"
        onKeyUp={handleTextChange}
      />
      <DataTable
        description="Basic"
        rows={searchInput ? filteredRows : rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        className="testscenario-table"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default TestScenarios
